<template>
  <div>
    <template v-if="openCustom">
      <template v-if="isNeedInquiry">单询</template>
      <template v-else-if="exemptionType === 2">免派</template>
      <template v-else>
        <template v-if="copyVipPrice">
          <div style="font-size: 12px;color:#999999;text-align:left;">普通价:{{ priceItem.ordinaryPrice }}</div>
          <div class="vip-row">
            <span style="margin-right: 4px;flex-shrink: 0">VIP价</span>
            <el-input v-model="priceItem.price" @change="changePriceInput" placeholder="请输入"
                      type="number" class="input-number__no-arrows vip-input" :disabled="isDetail"></el-input>
          </div>
        </template>
        <template v-else>
          <el-input
            v-model="priceItem.price"
            :disabled="exemptionType === 2"
            @change="changePriceInput"
            placeholder="请输入价格"
            type="number"
            class="input-number__no-arrows price-input"/>
        </template>
      </template>
    </template>
    <template v-else>
      <template v-if="isNeedInquiry">单询</template>
      <template v-else-if="exemptionType === 2">免派</template>
      <template v-else>
        {{ priceItem.price }}
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "customPriceColumn",
  props:{
    tableHeadRegionIndex:{
      type:Number,
      default:0,
    },
    priceItem:{
      type:Object,
      default:()=>({}),
    },
    openCustom:Boolean,//运行自定义价格
    isNeedInquiry:Boolean,//是否支持单询
    exemptionType:Number,//免派类型，1：不免派(默认)；2：免派
    copyVipPrice:Boolean,//是否复制vip价格
    isDetail:Boolean,
  },
  methods:{
    changePriceInput(val){
      this.$emit("change",val)
    },
  },
}
</script>

<style scoped lang="scss">
.vip-row {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333333;
  .vip-input {
    width: 60px;
    /deep/ .el-input__inner {
      width: 60px;
      height: 24px;
      min-height: unset !important;
      border: 1px solid #EEEEEE !important;
      font-size: 12px !important;
      &::placeholder {
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/cityCustomQuotationList/customPriceColumn.vue